import Layout from '/src/components/@common.blocks/Layout'
import DropsCalendar from '/src/components/@sections/DropsCalendar'

const UpcomingPage = () => {
  return (
    <Layout
      title='NFT Drops Calendar'
      description='Upcoming NFT Drops for Ethereum, Solana, Polygon blockchains. Explore the best today’s NFT drops.'
      footer={false}
    >
      <DropsCalendar />
    </Layout>
  )
}

export default UpcomingPage
